import { LOADER_HANDLER_TYPES, METHOD_TYPES } from 'constants/index'
import { microServices } from 'network/apis/microservice/index'
import axiosInstanceService from 'network/apis/index'
import { SuccessMessage } from 'network/messages/successMessages'

export const getMeshPayLinkTokenService = (data) => {
  return axiosInstanceService(METHOD_TYPES.post, '/mesh-pay/link-token', data, {
    server: microServices.SERVICE_URL_1,
    loader: LOADER_HANDLER_TYPES.submit
  })
}

export const notifyMeshTransferService = (data) => {
  return axiosInstanceService(METHOD_TYPES.post, '/mesh-pay/transfer-callback', data, {
    server: microServices.SERVICE_URL_1
  })
}

export const generatePaymentTokenService = (data) => {
  return axiosInstanceService(METHOD_TYPES.post, '/gigadat/generate-token', data, {
    server: microServices.SERVICE_URL_1,
    loader: LOADER_HANDLER_TYPES.submit
  })
}

export const generateCryptoPaymentTokenService = (data) => {
  console.error('api daata',data)
  return axiosInstanceService(METHOD_TYPES.post, '/mozarto/initiate-deposit-transaction', data, {
    server: microServices.SERVICE_URL_1,
    loader: LOADER_HANDLER_TYPES.submit
  })
}

export const wallet88PaymentService = (data) => {
  return axiosInstanceService(METHOD_TYPES.post, '/wallet88/bank-transfer', data, {
    server: microServices.SERVICE_URL_1,
    loader: LOADER_HANDLER_TYPES.submit
  })
}

export const wallet88EmtService = (data) => {
  return axiosInstanceService(METHOD_TYPES.post, '/wallet88/emt-transfer', data, {
    server: microServices.SERVICE_URL_1,
    loader: LOADER_HANDLER_TYPES.submit,
    successMessage: SuccessMessage.checkYourMailForFurtherDetails
  })
}

export const initiateCryptoWithdrawalService = (data) => {
  return axiosInstanceService(METHOD_TYPES.post, '/mozarto/withdraw-callback-fp', data, {
    server: microServices.SERVICE_URL_1,
    loader: LOADER_HANDLER_TYPES.submit
  })
}

export const checkForumPayStatusService = (paymentId, address, currency) => {
  return axiosInstanceService(METHOD_TYPES.get, '/mozarto/fp-payment-status', {}, {
    server: microServices.SERVICE_URL_1,
    suppressError: true,
    params: { payment_id: paymentId, ...(address && { address }), ...(currency && { currency }) }
  })
}
